module.exports = __webpack_public_path__ + "img/conceptual1.13b17b14.svg";